"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedisTopic = void 0;
var RedisTopic;
(function (RedisTopic) {
    RedisTopic["AUCTIONS"] = "auctions";
    RedisTopic["PACKS"] = "packs";
    RedisTopic["USERS"] = "users";
    RedisTopic["MAIN"] = "main";
})(RedisTopic || (exports.RedisTopic = RedisTopic = {}));
